/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type VisionBurnsFetchQueryVariables = Types.Exact<{
	fiatId: Types.Scalars["ID"];
}>;

export type VisionBurnsFetchQuery = {
	__typename?: "Query";
	visionBurns: {
		__typename?: "VisionBurnData";
		totalBurnedAmount: { __typename?: "CurrencyAmount"; value: string };
		nextBurnDate: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
		previousBurns: {
			__typename?: "VisionBurnTransactionResponse";
			transactions: Array<{
				__typename?: "VisionBurnTransaction";
				burnDate: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
				fiatAmount: { __typename?: "CurrencyAmount"; value: string };
				assetAmount: { __typename?: "CurrencyAmount"; value: string };
			}>;
			pageInfo: {
				__typename?: "PaginationResponse";
				currentPage: number;
				totalPages: number;
				totalItems: number;
			};
		};
	};
};

export const VisionBurnsFetchDocument = gql`
	query visionBurnsFetch($fiatId: ID!) {
		visionBurns(fiatId: $fiatId) {
			totalBurnedAmount {
				value
			}
			nextBurnDate {
				iso8601
				unixTimestamp
			}
			previousBurns {
				transactions {
					burnDate {
						iso8601
						unixTimestamp
					}
					fiatAmount {
						value
					}
					assetAmount {
						value
					}
				}
				pageInfo {
					currentPage
					totalPages
					totalItems
				}
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class VisionBurnsFetchGQLService extends Apollo.Query<VisionBurnsFetchQuery, VisionBurnsFetchQueryVariables> {
	document = VisionBurnsFetchDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
